<script>
export default {
  name: 'CollaborativeProcess',
  components: {
  },
  data () {
    return {
    }
  },
  computed: {
  }
}
</script>
<template>
  <section class="strategic-partnerships">
    <div class="responsive-rows">
      <article class="article-body">
        <header>
          <h2 class="article-title mb-2">Developed with Vision Therapy Experts</h2>
          <h3 class="article-subtitle">
            We’ve had a lot of help!
          </h3>
        </header>
        <p class="mt-4">Every game and activity on the Our Visual Brain platform is created with direct input from Vision Therapists and Doctors.</p>
        <p class="mt-2">Our Advisory Panel, comprised of industry professionals, reviews each activity before it is released to ensure that we meet current therapeutic standards.</p>
        <router-link
          class="button is-primary mt-4 mb-4 mb-0-tablet"
          :to="{ name: 'AboutView', params: {stickyNav: false}}"
        >
          Meet our Advisors
        </router-link>
      </article>
      <div class="advisor-grid">
        <div class="advisor-cell">
          <figure class="image">
            <img :src="require('@/assets/promo/img/home/team/ryan_capouch.webp')" alt="Dr. Ryan Capouch">
            <figcaption class="is-size-7">Dr. Ryan Capouch<br>OD FCOVD</figcaption>
          </figure>
        </div>
        <div class="advisor-cell">
          <figure class="image">
            <img :src="require('@/assets/promo/img/home/team/robyn_rakov.webp')" alt="Dr. Robyn Rakov">
            <figcaption class="is-size-7">Dr. Robyn Rakov<br>OD FCOVD</figcaption>
          </figure>
        </div>
        <div class="advisor-cell">
          <figure class="image">
            <img
              :src="require('@/assets/promo/img/home/team/carolanne_roach.webp')"
              alt="Dr. Carolanne Roach"
            >
            <figcaption class="is-size-7">Dr. Carolanne Roach<br>OD</figcaption>
          </figure>
        </div>
        <div class="advisor-cell">
          <figure class="image">
            <img :src="require('@/assets/promo/img/home/team/lisa_knopp.webp')" alt="Lisa Knopp">
            <figcaption class="is-size-7">Lisa Knopp<br>COVT, M.Ed.</figcaption>
          </figure>
        </div>
        <div class="advisor-cell">
          <figure class="image">
            <img :src="require('@/assets/promo/img/home/team/tiffany_tarbre.webp')" alt="Tiffany Tarbe">
            <figcaption class="is-size-7">Tiffany Tarbe<br> LDO, COTA/L</figcaption>
          </figure>
        </div>
      </div>
    </div>
  </section>
</template>
<style scoped lang="scss">
.strategic-partnerships-block {
  .card.collab-card {
    .card-content {
      padding: 0.5rem;
    }
  }
}
</style>
<style scoped lang="scss">
.advisor-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 2rem;
  grid-row-gap: 1rem;
  @include tablet {
    display: grid;
    grid-template-columns: repeat( auto-fill, minmax(9rem, 0.5fr));
    grid-column-gap: 2rem;
    grid-row-gap: 1rem;
  }
  @include desktop {}
  @include widescreen {}
  @include fullhd {}
  .advisor-cell {
    img {
      border-radius: 0.25rem;
      box-shadow: rgba(0, 0, 0, 0.1) 0 10px 50px;
    }
  }
}
.strategic-partnerships {
  display: block;
  position: relative;
  .collab-card {
    max-width: 8rem;
  }
  .collab-grid-container {
    //background-color: #cb5fae;
  }
  .collab-card-container {
    display: flex;
    align-items: center;
    justify-content: center;
    //border: 1px solid blue;
  }
  .collab-card-grid {
    //border: 1px solid red;
    flex-grow: 1;
    display: inline-grid;
    grid-template-columns: 1fr 1fr 1fr;
    //grid-template-columns: repeat( auto-fit, minmax(8rem, 8rem));
    grid-row-gap: 1rem;
    grid-column-gap: 1rem;
    margin: 0 1rem;
    @include tablet {
      grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
    }
    @include desktop {
      margin: 0;
    }
  }
  .collab-box-image {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 10rem;
    height: 10rem;
    border-radius: 20rem;
    overflow: hidden;
    //border: 1px solid red;
    figure {
      //display: flex;
      //align-items: center;
      //justify-content: center;
      //height: 10rem;
      //border-radius: 20rem;
      //overflow: hidden;
      img {
        height: 100%;
      }
    }
  }
  .responsive-rows {
    display: flex;
    flex-direction: column;
    //flex-wrap: wrap;
    @include tablet {
      display: grid;
      grid-template-columns: repeat( auto-fill, minmax(30rem, 1fr));
      grid-column-gap: 2rem;
      grid-row-gap: 1rem;
    }
    @include desktop {
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-column-gap: 2rem;
      grid-row-gap: 1rem;
    }
    @include widescreen {
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-column-gap: 2rem;
      grid-row-gap: 1rem;
    }
  }
}
</style>
